import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { TCreateTeaserSelectedContentType } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useMemo } from 'react';
import { teaserContentTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';

interface IClientTypeSelect {
	setContentType: (value: TCreateTeaserSelectedContentType) => void;
}

const ContentTypeSelect: React.FC<IClientTypeSelect> = ({ setContentType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectContentType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return teaserContentTypes.map((el) => ({ id: el.id, name: tForm(el.name) }));
	}, [tForm]);

	return (
		<FormSelect
			testId="ContentTypeSelect"
			name="selectedContentType"
			label="contentTypeLabel"
			options={mappedOptions}
			onChange={setContentType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ContentTypeSelect);
